import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Globe } from 'lucide-react';
import Logo from '../../assets/logo.webp';

const BlogSiteFooter = () => (
  <footer role="contentinfo" className="bg-gray-900 text-white py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-4 gap-8 mb-8">
        <div className="md:col-span-2">
          <div className="flex items-center mb-4">
            <img src={Logo} alt="Nirvana Career Counselling Logo" className="h-12 w-12 mr-3" />
            <h4 className="text-xl font-semibold">Nirvana Career Counselling</h4>
          </div>
          <p className="text-gray-300 mb-4 leading-relaxed">
            Expert career guidance for students and professionals across Bangalore, Jamshedpur, and Ranchi.
            Fully online sessions with 30+ years of experience.
          </p>
          <div className="flex items-center space-x-4">
            <div className="bg-teal-600 rounded-full p-2">
              <Phone className="h-4 w-4" />
            </div>
            <span className="text-gray-300">+91 9731166822</span>
          </div>
        </div>

        <div>
          <h5 className="text-lg font-semibold mb-4 text-teal-400">Service Areas</h5>
          <ul className="space-y-2 text-gray-300">
            <li className="flex items-center">
              <MapPin className="h-4 w-4 mr-2 text-teal-400" />
              <Link to="/bangalore" className="hover:text-teal-400 transition-colors">Bangalore, Karnataka</Link>
            </li>
            <li className="flex items-center">
              <MapPin className="h-4 w-4 mr-2 text-teal-400" />
              <Link to="/jamshedpur" className="hover:text-teal-400 transition-colors">Jamshedpur, Jharkhand</Link>
            </li>
            <li className="flex items-center">
              <MapPin className="h-4 w-4 mr-2 text-teal-400" />
              <Link to="/ranchi" className="hover:text-teal-400 transition-colors">Ranchi, Jharkhand</Link>
            </li>
            <li className="flex items-center">
              <Globe className="h-4 w-4 mr-2 text-teal-400" />
              <span>Online Consultations</span>
            </li>
          </ul>
        </div>

        <div>
          <h5 className="text-lg font-semibold mb-4 text-teal-400">Quick Links</h5>
          <ul className="space-y-2 text-gray-300">
            <li>
              <Link to="/" className="hover:text-teal-400 transition-colors">Home</Link>
            </li>
            <li>
              <Link to="/blog" className="hover:text-teal-400 transition-colors">Career Blog</Link>
            </li>
            <li>
              <Link to="/jamshedpur" className="hover:text-teal-400 transition-colors">Jamshedpur Counselling</Link>
            </li>
            <li>
              <Link to="/ranchi" className="hover:text-teal-400 transition-colors">Ranchi Counselling</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-700 pt-6 text-center">
        <p className="text-gray-300 mb-2">
          Copyright &copy; Nirvana Career Counselling
        </p>
        <p className="text-sm text-gray-400">
          Jharkhand &bull; Karnataka &bull; Online Counselling Available Nationwide
        </p>
        <p className="mt-2 text-sm text-gray-400">
          Rated 4.9/5 &bull; 30+ Years Experience &bull; 100% Confidential
        </p>
      </div>
    </div>
  </footer>
);

export default BlogSiteFooter;
